export default function convertDataToTranslation(data, t) {
  const content = []

  data.map((node) => {
    const key = Object.keys(node)[0]
    switch (key) {
      case 'h1':
      case 'h2':
      case 'h3':
      case 'h4':
      case 'p':
        content.push({ [key]: t(node[key]) })
        break
      case 'ul': {
        const listContent = []
        node.ul.map((item) => {
          listContent.push({ li: t(item.li) })
          return ''
        })
        content.push({ [key]: listContent })
        break
      }
      case 'ol': {
        const listContent = []
        node.ol.map((item) => {
          listContent.push({ li: t(item.li) })
          return ''
        })
        content.push({ [key]: listContent })
        break
      }
    }

    return ''
  })

  return content
}
